import { PoiHeadingEnum } from "./shared/enums/poi-heading-enum";
export class POISConstants {
    static Headings = {
        PageHeadings: "POI"
    };
    static SELECTED_POI_GRAPHICS_LAYER = "selectedPOIGraphicsLayer";
}
export const POISHeadingEnumHeadingLookup = new Map([
    [PoiHeadingEnum.name, "name"],
    [PoiHeadingEnum.alternativeName, "alternativeName"],
    [PoiHeadingEnum.address, "address"],
    [PoiHeadingEnum.type, "type"],
    [PoiHeadingEnum.ward, "ward"]
]);
